<template>
    <div ref="wrapperRef" class="relative w-full">
        <button
            v-if="showLeftArrow"
            type="button"
            class="max-md:hidden absolute -left-[15px] top-1/2 z-[1] flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full border-0 bg-white text-gray-500 shadow-[0_2px_4px_#445c8224,0_4px_5px_#445c821f,0_1px_10px_#445c8233] transition hover:bg-gray-100 active:scale-95"
            @click="scrollLeft"
        >
            <IconAngleLeft class="h-5 w-5"/>
        </button>

        <div
            ref="scrollRef"
            class="with-horizontal-drag-scroll w-full cursor-grab select-none overflow-x-auto overflow-y-hidden whitespace-nowrap scrollbar-none"
            :class="{ 'cursor-grabbing': isDragging }"
            @mousedown="onMouseDown"
            @mousemove="onMouseMove"
            @mouseup="stopDragging"
            @mouseleave="stopDragging"
            @scroll="updateArrows"
        >
            <slot/>
        </div>

        <button
            v-if="showRightArrow"
            type="button"
            class="max-md:hidden absolute -right-[15px] top-1/2 z-[1] flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full border-0 bg-white text-gray-500 shadow-[0_2px_4px_#445c8224,0_4px_5px_#445c821f,0_1px_10px_#445c8233] transition hover:bg-gray-100 active:scale-95"
            @click="scrollRight"
        >
            <IconAngleLeft class="h-5 w-5 rotate-180"/>
        </button>
    </div>
</template>

<script>
import {defineComponent, nextTick, onBeforeUnmount, onMounted, ref} from 'vue'
import IconAngleLeft from "@js/components/Icons/IconAngleLeft.vue";

export default defineComponent({
    name: 'HorizontalDragScroll',
    components: {IconAngleLeft},

    props: {
        scrollStep: {
            type: Number,
            default: 260,
        },
    },

    setup(props) {
        const wrapperRef = ref(null)
        const scrollRef = ref(null)

        const isDragging = ref(false)
        const showLeftArrow = ref(false)
        const showRightArrow = ref(false)

        let startX = 0
        let startScrollLeft = 0

        const updateArrows = () => {
            const el = scrollRef.value
            if (!el) return

            const maxScrollLeft = el.scrollWidth - el.clientWidth

            showLeftArrow.value = el.scrollLeft > 2
            showRightArrow.value = el.scrollLeft < maxScrollLeft - 2
        }

        const scrollLeft = () => {
            scrollRef.value?.scrollBy({
                left: -props.scrollStep,
                behavior: 'smooth',
            })
        }

        const scrollRight = () => {
            scrollRef.value?.scrollBy({
                left: props.scrollStep,
                behavior: 'smooth',
            })
        }

        const onMouseDown = (event) => {
            const el = scrollRef.value
            if (!el) return

            isDragging.value = true
            startX = event.pageX - el.offsetLeft
            startScrollLeft = el.scrollLeft

            event.preventDefault()
        }

        const onMouseMove = (event) => {
            const el = scrollRef.value
            if (!el || !isDragging.value) return

            const x = event.pageX - el.offsetLeft
            const walk = x - startX

            el.scrollLeft = startScrollLeft - walk
        }

        const stopDragging = () => {
            isDragging.value = false
        }

        onMounted(() => {
            nextTick(updateArrows)
            window.addEventListener('resize', updateArrows)
        })

        onBeforeUnmount(() => {
            window.removeEventListener('resize', updateArrows)
        })

        return {
            wrapperRef,
            scrollRef,
            isDragging,
            showLeftArrow,
            showRightArrow,
            scrollLeft,
            scrollRight,
            onMouseDown,
            onMouseMove,
            stopDragging,
            updateArrows,
        }
    },
})
</script>

<style scoped>
.with-horizontal-drag-scroll {
    scrollbar-width: none;
}

.with-horizontal-drag-scroll::-webkit-scrollbar {
    width: 0;
    height: 0;
}
</style>
